export function VersionFooter() {
  const raw = import.meta.env.VITE_APP_VERSION?.trim();
  const version = raw && !/^VITE_/.test(raw) ? raw : '0.0.0';

  return (
    <span className="pointer-events-none fixed bottom-2 right-3 z-50 select-none text-[10px] text-gray-400">
      v{version}
    </span>
  );
}
